import type { RootState } from 'src/store';
import type { ModuleButton } from './types';

const getModuleButtonsState = (state: RootState) => state?.moduleButtons;

export const getModuleButtons = (state: RootState): ModuleButton[] =>
  getModuleButtonsState(state)?.buttons || [];
